const INIT_STATE = {
    title: "Getting Users",
}

export const usersReducer = (state = INIT_STATE, action) => {
    switch(action.type){
        default:
            return { ...state }
    }
}